import {AxiosInstance, AxiosResponse} from 'axios';
//api
import {orgAPI, userAPI} from '@/core/api';
//types
import {
  IOrganizationBillingListResponse,
  IRequestBillingWithPagination,
  IStripeOnboardingResponse,
  MakePaymentOrgRequest,
  PaymentOrgRequest,
  PaymentOrgResponse,
  PaymentRes,
  StripeAccountDetails,
} from '@/utils/types';
//enum
import {API_URL} from '../enums/api-url.enum';

class OrganizationStripeService {
  static createStrapiOnboardingLink = async (
    id: number,
    data: {isRegistationFlow: boolean}
  ): Promise<AxiosResponse<IStripeOnboardingResponse>> =>
    orgAPI.post(`${API_URL.ORGANIZATION_INFO}/${id}/stripe/onboarding-link`, data);

  static ensureStrapiConnectedExist = async (id: number): Promise<AxiosResponse<StripeAccountDetails>> =>
    orgAPI.post(`${API_URL.ORGANIZATION_INFO}/${id}/stripe/ensure`);

  static getOrganizationStripePaymentSettings = async (id: number): Promise<AxiosResponse<StripeAccountDetails>> =>
    orgAPI.get(`${API_URL.ORGANIZATION_INFO}/${id}/payment-settings`);

  static syncOrganizationStripeConnection = async (id: number): Promise<AxiosResponse<StripeAccountDetails>> =>
    orgAPI.post(`${API_URL.ORGANIZATION_INFO}/${id}/stripe/sync`);

  static disableOrganizationStripeConnection = async (id: number): Promise<AxiosResponse<StripeAccountDetails>> =>
    orgAPI.post(`${API_URL.ORGANIZATION_INFO}/${id}/stripe/disable`);

  static enableOrganizationStripeConnection = async (id: number): Promise<AxiosResponse<StripeAccountDetails>> =>
    orgAPI.post(`${API_URL.ORGANIZATION_INFO}/${id}/stripe/enable`);

  static checkPaymentStatus = async (id: number, apiInstance: AxiosInstance): Promise<AxiosResponse<PaymentRes>> =>
    apiInstance.get(`${API_URL.PAYMENT}/${id}`);

  static sendPaymentLink = async (attendeeId: number, eventId: number): Promise<AxiosResponse> =>
    orgAPI.post(`${API_URL.GET_ATTENDEE_AUCTION_CONTRIBUTIONS}/${attendeeId}/send-payment-link`, {eventId});

  static paymentOrgStripe = async (
    attendeeId: number,
    body: PaymentOrgRequest
  ): Promise<AxiosResponse<PaymentOrgResponse>> =>
    orgAPI.post(`${API_URL.GET_ATTENDEE_AUCTION_CONTRIBUTIONS}/${attendeeId}/org-checkout`, body);

  static paymentUserStripe = async (
    attendeeId: number,
    body: PaymentOrgRequest
  ): Promise<AxiosResponse<PaymentOrgResponse>> =>
    userAPI.post(`${API_URL.GET_ATTENDEE_AUCTION_CONTRIBUTIONS}/${attendeeId}/checkout`, body);

  static makePaidOrg = async (attendeeId: number, body: MakePaymentOrgRequest): Promise<AxiosResponse> =>
    orgAPI.post(`${API_URL.GET_ATTENDEE_AUCTION_CONTRIBUTIONS}/${attendeeId}/mark-paid`, body);

  static getBillingList = async (
    reqBody: IRequestBillingWithPagination
  ): Promise<AxiosResponse<IOrganizationBillingListResponse>> => orgAPI.post(API_URL.PAYMENT_BILLING_HISTORY, reqBody);
}

export {OrganizationStripeService};
